<script>
    let backdiv1;
    let backdiv2;
    let backdiv3;
    let backdiv4;
    let backdiv5;
    let backImg;
    let leftTxt;
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Future of Gaming');
    import {onMount} from 'svelte';
    /**
     * Adds two numbers together.
     */
    function backfill() {
        leftTxt.style.opacity = '100%';
        backdiv1.style.right = '0vh';
        backdiv2.style.right = '0vh';
        backdiv3.style.right = '0vh';
        backdiv4.style.right = '0vh';
        backdiv5.style.right = '0vh';
        backImg.style.left = '0vh';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(backfill, 10);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            goto('/technology');
        }
        if (e.key == 'ArrowLeft') {
            goto('/outcomes');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<section role = 'presentation' on:click={()=> goto('/technology')}>
    <div class="bgImageWrraper" bind:this={backImg}>
        <img
            src="/images/future2.png"
            alt="background"
            width="100%"
            height="100%"
        />
    </div>
    <div class="theFuture" bind:this={leftTxt}>
        <h1>THE<br />FUTURE</h1>
        <p>
            The potential of cross-industry applications of game-tech is stalled
            by its lack of scalability.
        </p>
        <p class="textclr">
            OPUS is the transformative technology that solves it.
        </p>
    </div>
    <div class="textRightWrraper">
        <div class="textRight">
            <h1>B2B</h1>
            <p>ARCHITECTURE & URBAN PLANNING</p>
            <div class="backclr" bind:this={backdiv1}/>
        </div>
        <div class="textRight">
            <h1>ED TECH</h1>
            <p>INTERACTIVE EDUCATION</p>
            <div class="backclr" bind:this={backdiv2}/>
        </div>
        <div class="textRight">
            <h1>GOV TECH</h1>
            <p>SCIENTIFIC SIMULATION</p>
            <div class="backclr" bind:this={backdiv3}/>
        </div>
        <div class="textRight">
            <h1>MEDIA TECH</h1>
            <p>NON INTERACTIVE / INTERACTIVE FICTION</p>
            <div class="backclr" bind:this={backdiv4}/>
        </div>
        <div class="textRight">
            <h1>INDUSTRIAL TECH</h1>
            <p>ROBOTICS & INDUSTRIAL SIMULATION</p>
            <div class="backclr" bind:this={backdiv5}/>
        </div>
    </div>
</section>

<style>
    section {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        font-style: normal;
        position: relative;
        font-family: "Montserrat";
        background-color: #010422;
    }
    section::after{
        content: "";
        position: absolute;
        width: inherit;
        height: inherit;
        top: 0;
        z-index: 100;
        background-color: transparent;
    }
    .bgImageWrraper {
        width: 59.635vw;
        height: auto;
        position: relative;
        top: 0;
        left: 32vw;
        transition-duration: 0.5s;
    }
    .theFuture {
        position: absolute;
        left: 9.167vw;
        top: 12.8vh;
        opacity: 0%;
        transition-duration: 0.5s;
    }
    .theFuture h1 {
        font-weight: 900;
        color: #ff007f;
        font-size: 13.889vh;
        line-height: 78.9%;
        text-transform: uppercase;
        margin-bottom: 0vh;
    }
    .theFuture p {
        font-size: 2.778vh;
        line-height: 100%;
        color: #ffffff;
        font-weight: 400;
        width: 70vh;
    }
    .theFuture .textclr {
        color: rgba(255, 204, 51, 1);
        font-size: 2.778vh;
        line-height: 100%;
        font-weight: 800;
        width: 58vh;
    }
    .textRightWrraper {
        position: absolute;
        top: 13.3vh;
        right: 0;
    }
    .textRight:nth-child(1) {
        height: fit-content;
        width: 60.167vh;
        padding: 0.5vw 0;
        margin-bottom: 1.5vw;
        margin-left: auto;
        padding-right: 2vh;
        position: relative;
    }
    .textRight:nth-child(1) .backclr {
        background-color: #ff007f;
        width: 60.167vh;
        height:13vh;
        position : absolute;
        top: 0vh;
        right:-20vh;
        transition-duration:0.5s;
    }
    .textRight:nth-child(2) {
        /* background-color: #ff007f; */
        height: fit-content;
        width: 49.833vh;
        padding: 0.5vw 0;
        margin-bottom: 1.5vw;
        margin-left: auto;
        padding-right: 2vh;
        position: relative;
    }
    .textRight:nth-child(2) .backclr {
        background-color: #ff007f;
        width: 49.833vh;
        height:13vh;
        position : absolute;
        top: 0vh;
        right:-20vh;
        transition-duration:0.5s;
    }
    .textRight:nth-child(3) {
        /* background-color: #ff007f; */
        height: fit-content;
        width: 56.167vh;
        padding: 0.5vw 0;
        margin-bottom: 1.5vw;
        margin-left: auto;
        padding-right: 2vh;
        position: relative;
    }
    .textRight:nth-child(3) .backclr {
        background-color: #ff007f;
        width: 56.167vh;
        height:13vh;
        position : absolute;
        top: 0vh;
        right:-20vh;
        transition-duration:0.5s;
    }
    .textRight:nth-child(4) {
        /* background-color: #ff007f; */
        height: fit-content;
        width: 68.365vh;
        padding: 0.5vw 0;
        margin-bottom: 1.5vw;
        margin-left: auto;
        padding-right: 2vh;
        position: relative;
    }
    .textRight:nth-child(4) .backclr {
        background-color: #ff007f;
        width: 68.365vh;
        height:13vh;
        position : absolute;
        top: 0vh;
        right:-20vh;
        transition-duration:0.5s;
    }
    .textRight:nth-child(5) {
        /* background-color: #ff007f; */
        height: fit-content;
        width: 95.781vh;
        padding: 0.5vw 0;
        margin-bottom: 1.5vw;
        margin-left: auto;
        padding-right: 2vh;
        position: relative;
    }
    .textRight:nth-child(5) .backclr {
        background-color: #ff007f;
        width: 95.781vh;
        height:13vh;
        position : absolute;
        top: 0vh;
        right:-20vh;
        transition-duration:0.5s;
    }
    .textRight h1 {
        margin: 0;
        color: #ffffff;
        font-weight: 900;
        text-align: right;
        font-size: 9.259vh;
        line-height: 84.4%;
        text-transform: uppercase;
        position: relative;
        z-index: 1;
    }
    .textRight p {
        margin: 0;
        text-align: end;
        color: #ffffff;
        font-weight: 400;
        line-height: 100%;
        font-size: 2.778vh;
        position: relative;
        z-index: 1;
    }
</style>
